import type { FaireProductEntity } from "../../entity_types/product";

export const p_384nsamf62: FaireProductEntity = {
  token: "p_384nsamf62",
  type: "product",
  name: "Apple a Day Thank You Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/7f62f4326eb7a28003aacff217b9d8279adca6b05bd4e40ee27e53a6a598dc0b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/894e98d416bbfccf7fe67ef68b0ecf63742e044fa98fa03f71efe18ee8ebad6c.jpeg",
    "https://cdn.faire.com/fastly/46028691c7db88a5391ef7ca383d4264ec0458353a605834a81dd73c775175af.jpeg",
  ],
  priceDollars: 3,
  description:
    "A lot of pressure we have put on this fruit, to suggest they are only thing you need to keep doctors away. So our thanks, heartfelt, goes to the apples.",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:10.169Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
